<template>
  <div class="font-alignement">
    <v-icon @click="setAlign('left')" :color="this.alignement == 'left' ? 'primary' : 'black'">mdi-format-align-left</v-icon>
    <v-icon @click="setAlign('center')" :color="this.alignement == 'center' ? 'primary' : 'black'">mdi-format-align-center</v-icon>
    <v-icon @click="setAlign('right')" :color="this.alignement == 'right' ? 'primary' : 'black'">mdi-format-align-right</v-icon>
  </div>
</template>

<script>

export default {
  name: 'FontAlignement',
  props: ['styles'],
  computed: {},
  watch: {
    alignement (newVal) {
      if (newVal !== 'clear') {
        this.$emit('update:styles', { textAlign: this.alignement })
      } else {
        this.$emit('update:styles', { textAlign: 'left' })
      }
    }
  },
  data () {
    return {
      alignement: 'left'
    }
  },
  created () {
    if (this.styles && this.styles.textAlign) {
      this.alignement = this.styles.textAlign
    }
  },
  methods: {
    setAlign (alignement) {
      this.alignement = alignement
    },

    reset () {
      this.alignement = 'left'
    }
  }
}

</script>

<style lang="sass" scoped>

</style>
